import { DialogCb } from 'hooks/use-dialog-modal';
import { IOrder } from 'state/order/types';
import { ServiceMode } from 'state/service-mode';
import { routes } from 'utils/routing';

interface ICateringNavProps {
  isCatering: IOrder['isCatering'];
  cartEntries: IOrder['cartEntries'];
  isStoreOpenAndAvailable: boolean;
  showConfirmationDialog: DialogCb<{}>;
  navigate: (to: string) => void;
}

interface IHandleConfirm {
  selectServiceMode: (mode: ServiceMode | null) => Promise<boolean>;
  resetStore: VoidFunction;
  emptyCart: VoidFunction;
  navigate: (to: string) => void;
}

export const handleCateringClick = ({
  isCatering,
  cartEntries,
  isStoreOpenAndAvailable,
  showConfirmationDialog,
  navigate,
}: ICateringNavProps) => {
  if (!isCatering && cartEntries.length > 0) {
    showConfirmationDialog();
  } else if (isCatering) {
    const route = isStoreOpenAndAvailable ? routes.menu : routes.serviceModeCatering;
    navigate(route);
  } else {
    navigate(routes.serviceModeCatering);
  }
};

export const handleConfirm = ({
  selectServiceMode,
  resetStore,
  emptyCart,
  navigate,
}: IHandleConfirm) => {
  selectServiceMode(null);
  resetStore();
  emptyCart();
  navigate(routes.serviceModeCatering);
};
